import { VesselParticulars } from './vessel-particulars';

export interface VesselParticularsStoreState {
  readonly vesselParticulars: VesselParticulars | undefined;
  readonly isFetchingVesselParticulars: boolean;
  readonly fetchError: string | undefined;
}

export const INITIAL_VESSEL_PARTICULARS_STORE_STATE: VesselParticularsStoreState = {
  vesselParticulars: undefined,
  isFetchingVesselParticulars: false,
  fetchError: undefined,
};
